<template>
  <div class="funder-documents">
    <div class="container">
      <div class="row">
        <div class="col-12">
          <h1>{{ furtherDocumentsPageHeading }}</h1>
        </div>
      </div>
      <div class="row">
        <div class="col-12">
          <iframe :src="iframeURL" width="100%" class="funder-docs-iframe"/>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "funder-documents",
  props: ['order', 'driverProfile', 'product'],
  computed: {
    iframeURL() {
      const uri = process.env.MIX_CAR_BENEFIT_URL;
      const apikey = process.env.MIX_CAR_BENEFIT_APIKEY
      const orderNumber = this.order.orderID;
      const emailAddress = this.driverProfile.contacts[0].emailAddress;

      return "https://" + uri + "/CBS/ExternalSupport/GetAgreementDocumentForSigning?orderno=" + orderNumber + "&driveremail=" + emailAddress + "&apikey=" + apikey
    },
    furtherDocumentsPageHeading() {
      return this.product?.further_documents_page_heading ? this.product.further_documents_page_heading : '';
    },
  }
}
</script>

<style scoped lang="scss">

.funder-documents {
  padding: 4rem 0;
}

.funder-docs-iframe {
  min-height: 200vh;
  border: 0;
}

</style>
